// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3f6pZ","imageUploader":"EGiftCard_imageUploader__3LMJv"};